module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selfservice.createTenant.title":"Create a new Customer Account","selfservice.createTenant.name":"Customer Name","selfservice.createTenant.billingEmail":"Billing Email Address"}}')
  delete Component.options._Ctor
}
